/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'

import { SkeletonText } from 'src/components/ts-components/SkeletonBlock'

const STAT_COUNT = 4

/** Cold-load placeholder for the This Week strip: title, number blocks, streak badge. */
const ThisWeekStripSkeleton = () => {
  'use memo'

  return (
    <div aria-hidden='true' css={stripStyles}>
      <div css={columnStyles}>
        <SkeletonText width={88} height={20} />
        <SkeletonText width={112} height={14} />
      </div>
      <div css={dividerStyles} />
      <div css={statsStyles}>
        {Array.from({ length: STAT_COUNT }, (_, i) => (
          <div key={i} css={columnStyles}>
            <SkeletonText width={32} height={24} />
            <SkeletonText width={32} height={12} />
          </div>
        ))}
      </div>
      <div css={spacerStyles} />
      <SkeletonText width={136} height={32} />
    </div>
  )
}

// ─── Styles ──────────────────────────────────────────────────────

const stripStyles = css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 24px;
  padding: 16px 24px;
  border: 1px solid ${colors.SECONDARY_300};
  border-radius: 8px;
  background: ${colors.SECONDARY_400};
`

const columnStyles = css`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const dividerStyles = css`
  align-self: stretch;
  width: 1px;
  background: ${colors.SECONDARY_200};
`

const statsStyles = css`
  display: flex;
  gap: 24px;
`

const spacerStyles = css`
  flex: 1;
`

export default ThisWeekStripSkeleton
